<template>
    <div class="content-box">
        <div class="title">
            <h2>专家访谈</h2>

            <!-- <el-link
            href="/zt/dsft/"
            target="_blank"
            :underline="false">
            更多访谈</el-link> -->
        </div>

        <div v-loading="loading">
            <div class="text">
                <a
                v-for="(i, index) in text"
                :key="index"
                :href="'/detail--' + i.id + '.html'"
                target="_blank">
                    <div class="img">
                        <el-image v-if="index <= 30" :src="require('@/assets/' + index + '.jpg')" lazy></el-image>
                        <el-image v-else :src="require('@/assets/' + (index % 30) + '.jpg')" lazy></el-image>
                    </div>
                    <div class="con">
                        <span>{{ i.title }}</span>
                        <p>{{ i.post_date.split(/T|Z/).join(' ') }}</p>
                    </div>
                </a>
            </div>
        </div>

        <div
        class="more"
        v-if="more">
            <el-button
            type="primary"
            plain
            @click="broadCast()">
            查看更多</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "interview",
    data() {
        return {
            size: 0,
            text: [],
            more: true,
            loading: false,
        }
    },
    mounted() {
        this.broadCast()
    },
    methods: {
        broadCast() {
            this.loading = true
            this.size += 10
            axios.get('/searchjson.html?p=1&n=' + this.size + '&terms=私域 访谈')
            .then((res) => {
                this.loading = false
                this.text = res.data.list
                if(this.size > res.data.list.length) {
                    this.more = false
                }else {
                    this.more = true
                }
            })
        }
    },
};
</script>